export default "__VITE_ASSET__C2L5uqDT__"